// The SDK's ping request has no timeout of its own (Kade SDK 0.7.0), so a hung
// Kade server would otherwise keep the check waiting for the whole session
export const SDK_INIT_TIMEOUT = 5 * 1000;
export const PING_TIMEOUT = 10 * 1000;
